interface ICardType {
  disabled?: boolean;
  isCreditCard?: boolean;
}

export const CardType = ({ disabled, isCreditCard }: ICardType) => {
  return (
    <p
      className={`co-h-fit co-flex co-px-4px co-py-2px co-rounded-4px co-font-semibold co-text-body2 co-text-white ${
        disabled ? 'co-bg-pds-neutral-300' : 'co-bg-cyan-primary'
      }`}
    >
      {isCreditCard ? 'Crédito' : 'Débito'}
    </p>
  );
};
